// extracted by mini-css-extract-plugin
export default {"cardbillboard_container":"CardBillboard_cardbillboard_container__11Sm4","cardbillboard":"CardBillboard_cardbillboard__REIM7","active":"CardBillboard_active__u-HId"};